export default __webpack_public_path__ + "static/media/V_Vaca.d3e58232.svg";